/* Meg Cookie Cutters — dreamy multi-layer sky parallax.
   Publishes the scroll position as --sky-y; each sky layer multiplies it by
   its own depth factor in CSS, so nearer layers move more than far ones.
   Purely presentational; respects reduced-motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rnd(min, max) { return min + Math.random() * (max - min); }
  function pick(n) { return 1 + Math.floor(Math.random() * n); } // 1..n

  // Return n well-spread {x,y} positions (in %) via a jittered grid so elements
  // never clump in the same spot.
  function spread(n, xMin, xMax, yMin, yMax) {
    var cols = Math.max(2, Math.round(Math.sqrt(n * (xMax - xMin) / (yMax - yMin))));
    var rows = Math.ceil(n / cols);
    var cells = [];
    for (var r = 0; r < rows; r++) for (var c = 0; c < cols; c++) cells.push([c, r]);
    for (var i = cells.length - 1; i > 0; i--) {         // shuffle
      var j = Math.floor(Math.random() * (i + 1));
      var t = cells[i]; cells[i] = cells[j]; cells[j] = t;
    }
    var cw = (xMax - xMin) / cols, ch = (yMax - yMin) / rows;
    return cells.slice(0, n).map(function (cell) {
      // small jitter only → cells stay evenly covered, nothing clumps
      return {
        x: xMin + (cell[0] + 0.5) * cw + (Math.random() - 0.5) * cw * 0.45,
        y: yMin + (cell[1] + 0.5) * ch + (Math.random() - 0.5) * ch * 0.45
      };
    });
  }

  // --- fill a container with N generated elements ----------------------------
  function fill(selector, count, make) {
    var box = document.querySelector(selector);
    if (!box || box.childElementCount) return;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < count; i++) frag.appendChild(make(i));
    box.appendChild(frag);
  }

  // random slow drift along ONE axis (horizontal or vertical), returns {dx,dy}
  function axisDrift(min, max) {
    var amt = rnd(min, max) * (Math.random() < 0.5 ? -1 : 1);
    return Math.random() < 0.5
      ? { dx: amt.toFixed(0) + 'px', dy: '0px' }
      : { dx: '0px', dy: amt.toFixed(0) + 'px' };
  }

  // image groups (white rollers 13–16 intentionally excluded)
  var GOLD = [1, 2, 3];                       // gold name toppers — always shown, large, in the side margins
  var STAMPS = [5, 6];                        // it's a boy / it's a girl — many & tiny
  var PINK = [4, 7, 8, 9, 10, 11, 12];        // pink/purple rollers & toppers — small
  var COOKIES = [17, 18, 19, 20, 21, 27, 28, 29, 30, 31,
                 32, 33, 34, 35, 36];         // decorated cookies — medium
  var CUTTERS = [24, 25, 26];                 // star / heart / cloud cutters — small

  function makeObj(n, size, x, y, drift, op) {
    var el = document.createElement('span');
    el.className = 'meg-cloud';
    el.style.cssText =
      '--img:var(--meg-obj-' + n + ');' +
      '--x:' + x.toFixed(1) + '%;' +
      '--y:' + y.toFixed(1) + '%;' +
      '--w:' + size.toFixed(0) + 'px;' +
      '--dx:' + drift.dx + ';--dy:' + drift.dy + ';' +
      '--dur:' + rnd(63, 113).toFixed(0) + 's;' +
      '--delay:-' + rnd(0, 120).toFixed(0) + 's;' +
      '--op:' + op.toFixed(2) + ';';
    return el;
  }

  function spawnSky() {
    var box = document.querySelector('.meg-sky__clouds');
    if (!box || box.childElementCount) return spawnRest();
    var frag = document.createDocumentFragment();

    function shuffled(arr) {
      var a = arr.slice();
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }

    if (reduce) {
      [1, 2, 3, 5, 6, 8, 17].forEach(function (n, i) {
        frag.appendChild(makeObj(n, 120, (i * 13 + 8) % 92, (i * 11 + 10) % 80, { dx: '0px', dy: '0px' }, 0.95));
      });
      box.appendChild(frag);
      return spawnRest();
    }

    // 1) gold names — always ALL three, LARGE, and parked in the left/right page
    //    margins so the content column never covers them (Emily stays readable).
    var goldSlots = [
      { x: 4, y: 18 }, { x: 88, y: 44 }, { x: 5, y: 68 }
    ];
    shuffled(GOLD).forEach(function (n, i) {
      var s = goldSlots[i % goldSlots.length];
      frag.appendChild(makeObj(
        n, rnd(190, 260),
        s.x + rnd(-2, 3), s.y + rnd(-5, 5),
        axisDrift(90, 200), 1
      ));
    });

    // 2) pink/purple rollers & toppers — one of each, SMALL (no duplicates now
    //    that the image library is much bigger)
    var pinkList = shuffled(PINK);
    var pp = spread(pinkList.length, -3, 95, 2, 92);
    pinkList.forEach(function (n, k) {
      frag.appendChild(makeObj(n, rnd(52, 92), pp[k].x, pp[k].y, axisDrift(120, 300), rnd(0.9, 1)));
    });

    // 3) decorated cookies — one of each, medium size
    var cookieList = shuffled(COOKIES);
    var cp = spread(cookieList.length, -2, 94, 3, 92);
    cookieList.forEach(function (n, k) {
      frag.appendChild(makeObj(n, rnd(85, 145), cp[k].x, cp[k].y, axisDrift(120, 300), rnd(0.92, 1)));
    });

    // 3b) star / heart / cloud cutters — one of each, small
    var cutterList = shuffled(CUTTERS);
    var xp = spread(cutterList.length, 0, 94, 4, 90);
    cutterList.forEach(function (n, k) {
      frag.appendChild(makeObj(n, rnd(55, 95), xp[k].x, xp[k].y, axisDrift(110, 260), rnd(0.9, 1)));
    });

    // 4) tiny it's-a-boy / it's-a-girl stamps (only 2 images, so a few repeats)
    var stampN = 6;
    var sp = spread(stampN, 2, 94, 4, 90);
    for (var s = 0; s < stampN; s++) {
      frag.appendChild(makeObj(STAMPS[s % 2], rnd(38, 64), sp[s].x, sp[s].y, axisDrift(80, 200), rnd(0.9, 1)));
    }

    box.appendChild(frag);
    spawnRest();
  }

  function spawnRest() {

    // Glossy stars (3 PNGs): spread, slowly rotating on themselves + soft glow.
    var starN = reduce ? 5 : 9;
    var starPos = spread(starN, 2, 94, 4, 90);
    fill('.meg-sky__glowstars', starN, function (i) {
      var el = document.createElement('span');
      el.className = 'meg-glowstar';
      el.style.cssText =
        '--img:var(--meg-star-' + pick(3) + ');' +
        '--x:' + starPos[i].x.toFixed(1) + '%;' +
        '--y:' + starPos[i].y.toFixed(1) + '%;' +
        '--size:' + rnd(24, 60).toFixed(0) + 'px;' +
        '--spin:' + rnd(32, 63).toFixed(0) + 's;' +   // self-rotation (another 15% faster)
        '--dur:' + rnd(4, 8).toFixed(1) + 's;' +
        '--delay:-' + rnd(0, 8).toFixed(1) + 's;' +
        '--op:' + rnd(0.75, 1).toFixed(2) + ';' +
        (Math.random() < 0.5 ? 'animation-direction:reverse,alternate;' : '');
      return el;
    });

    // Hearts (3 PNGs): spread, drift in one axis + gentle glow.
    var heartN = reduce ? 8 : 15;
    var heartPos = spread(heartN, -2, 96, 2, 92);
    fill('.meg-sky__hearts', heartN, function (i) {
      var el = document.createElement('span');
      el.className = 'meg-heart';
      var d = axisDrift(30, 90);
      el.style.cssText =
        '--img:var(--meg-heart-' + pick(3) + ');' +
        '--x:' + heartPos[i].x.toFixed(1) + '%;' +
        '--y:' + heartPos[i].y.toFixed(1) + '%;' +
        '--size:' + rnd(16, 40).toFixed(0) + 'px;' +
        '--dx:' + d.dx + ';--dy:' + d.dy + ';' +
        '--dur:' + rnd(57, 106).toFixed(0) + 's;' +   // faster (another 15%)
        '--delay:-' + rnd(0, 100).toFixed(0) + 's;' +
        '--tw:' + rnd(6, 11).toFixed(1) + 's;' +
        '--op:' + rnd(0.6, 0.95).toFixed(2) + ';';
      return el;
    });
  }

  // Build the decorative sky only once the page has finished loading, and even
  // then during idle time. The backdrop is purely cosmetic, so it must never
  // compete for bandwidth/CPU with product content or app scripts (sale labels,
  // discount countdowns), which is what made prices appear late.
  function scheduleSky() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(spawnSky, { timeout: 2000 });
    } else {
      setTimeout(spawnSky, 200);
    }
  }

  if (document.readyState === 'complete') {
    scheduleSky();
  } else {
    window.addEventListener('load', scheduleSky, { once: true });
  }

  // --- scroll parallax (skipped entirely under reduced-motion) ---------------
  if (reduce) {
    return;
  }

  var root = document.documentElement;
  var ticking = false;

  function update() {
    var y = window.pageYOffset || root.scrollTop || 0;
    root.style.setProperty('--sky-y', y.toFixed(1) + 'px');
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
